import type { specialOffers } from 'shared';

import type { hotOffersTypes } from '@/entities/hot-offers';

import { amplitudeEventsConfig } from '@/shared/config';

export const buildSearchQuery = (
  offer: hotOffersTypes.MappedHotOffer,
  currentSpecialOffer?: specialOffers.Special,
) => {
  const depDate = offer.dep_at.split('T')[0];
  const formattedDepDate = depDate.split('-').join('');
  if (currentSpecialOffer) {
    return {
      query: `${offer.origin.city.iata_code}-${offer.destination.city.iata_code}${formattedDepDate}1000E`,
      source: amplitudeEventsConfig.SERP_OPEN_SOURCE.SPECIAL_OFFERS,
    };
  }
  return {
    query: `${offer.origin.city.code}-${offer.destination.city.code}${formattedDepDate}1000E`,
    source: amplitudeEventsConfig.SERP_OPEN_SOURCE.HOT_OFFERS,
  };
};
